import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Slide } from "@mui/material";
import { forwardRef, useState } from "react";
import { orgCnDelete } from "./edit_halper";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function DeleteConsignment({ data, open, handleClose, onSuccess }) {
    const [isLoading, setIsLoading] = useState(false);

    const handleSelfClose = () => {
        if (isLoading) return;
        setIsLoading(false);
        handleClose();
    }

    const handleDelete = () => {
        setIsLoading(true);
        orgCnDelete(data.cn_no).then((_) => {
            if (onSuccess) onSuccess({ "task": "delete", "cn": data.cn_no });
            setIsLoading(false);
            handleSelfClose();
        }).catch((err) => {
            console.error(err);
            setIsLoading(false);
        });
    }

    if (data === null) return (<></>);
    return (
        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition}>
            <DialogTitle color="info">{data.cn_no}</DialogTitle>
            <DialogContent>
                Do you want to delete this consignment?
            </DialogContent>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <DialogActions sx={{ pb: 3, px: 3 }}>
                <Button variant="contained" color="error" onClick={handleDelete}>Delete</Button>
                <Button variant="outlined" onClick={handleSelfClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}
export default DeleteConsignment;